<template>
  <div class="header">
    <div class="header__column header__column--back-nav">
      <div
        class="header__back-nav back-nav"
        @click="$emit('close')"
      >
        <div class="back-nav__icon" />
        <h1>{{ item.title }}</h1>
      </div>
    </div>
    <div class="header__column header__column--media-nav">
      <MediaTypes
        :is-disabled="isLoading"
        @update-media-type="(mediaType: EMediaTypes) => $emit('update-media-type', mediaType)"
      />
    </div>
    <div class="header__column header__column--select-btn">
      <button
        :class="[
          'header__select-btn btn btn--black',
          { 'header__select-btn--disabled': isLoading },
        ]"
        @click="$emit('select')"
      >
        Выбрать
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Types } from '@/entities/site-template';
import { MediaTypes } from '@/shared/ui';
import type { EMediaTypes } from '@/types';

defineProps({
  item: {
    type: Object as PropType<Types.ISiteTemplate>,
    default: () => ({}),
  },

  isLoading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  selectedMediaType: {
    type: String as PropType<string>,
    required: true,
  },
});

defineEmits(['select', 'close', 'update-media-type']);
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  padding: 30px 40px 30px;
  background-color: white;

  &__back-nav {
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;

    .back-nav {
      &__icon {
        background-image: url('./images/arrow-back.svg');
        background-size: 30px 14px;
        background-repeat: no-repeat;
        background-position: center center;
        width: 48px;
        height: 48px;
      }

      h1 {
        font-family: 'OpenSans';
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        margin: 0;
      }
    }
  }

  &__select-btn {
    width: 200px;
    margin-right: 40px;

    &--disabled {
      background-color: #b2b2b2;
      border-color: #b2b2b2;
    }
  }
}
</style>
